export default __webpack_public_path__ + "assets/images/2f8b6e84ba4ca8e3c5efbd4a1cca68e6.svg";